<div class="p-3 c2wow-preview-area" [innerHTML]="sanitizer.bypassSecurityTrustHtml(htmlContent)"></div>
